function toggleDropdown() {
  const dropdown = document.getElementById("myDropdown");
  const arrow = document.querySelector(".arrow");

  dropdown.classList.toggle("show");
  
  if (dropdown.classList.contains("show")) {
    arrow.classList.add("up");
    arrow.classList.remove("down");
  } else {
    arrow.classList.add("down");
    arrow.classList.remove("up");
  }
}

// Chiusura del dropdown se si clicca fuori
window.onclick = function(event) {
  const dropdown = document.getElementById("myDropdown");
  const arrow = document.querySelector(".arrow");

  if (!event.target.matches('.dropbtn') && !event.target.closest('.dropbtn')) {
    if (dropdown.classList.contains('show')) {
      dropdown.classList.remove('show');
      arrow.classList.add("down");
      arrow.classList.remove("up");
    }
  }
};

// Gestione del click sui link dropdown
document.querySelectorAll('.dropdown-content a').forEach(function(link) {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    handleDropdownLinkClick(link);
  });
});

function handleDropdownLinkClick(link) {
  document.getElementById('myDropdown').classList.remove('show');
  const arrow = document.querySelector(".arrow");
  arrow.classList.add("down");
  arrow.classList.remove("up");

  if (link.textContent.includes("SPID")) {
    EntraConSpid();
  } else if (link.textContent.includes("CIE")) {
    EntraConCIE();
  }
}

function EntraConSpid() {
  console.log("Entra con SPID clicked");
}

function EntraConCIE() {
  console.log("Entra con CIE clicked");
}
